"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCashTransfer = exports.isDiscountPayment = exports.isRefundPayment = void 0;
const accounting_1 = require("../constants/accounting");
/**
 * Helper method for checking if a payment is a refund
 * It uses the payment transType to check if it is a refund
 */
const isRefundPayment = (payment) => {
    return payment.transactionType === accounting_1.TransactionType.REFUND;
};
exports.isRefundPayment = isRefundPayment;
/**
 * Helper method for checking if a payment is a discount
 * It uses the payment transType to check if it is a discount
 */
const isDiscountPayment = (payment) => {
    return (payment.transactionType === accounting_1.TransactionType.DISCOUNT &&
        !accounting_1.VOUCHER_PAYMENT_METHODS.includes(payment.type));
};
exports.isDiscountPayment = isDiscountPayment;
/**
 * Helper method for checking if a payment is a cash transfer
 */
const isCashTransfer = (payment) => {
    return payment.transactionType === accounting_1.TransactionType.CASH_TRANSFER;
};
exports.isCashTransfer = isCashTransfer;
//# sourceMappingURL=accounting.js.map